export const DocumentBuilderRoute = {
  DOCUMENTBUILDER: {
    path: 'documentbuilder',
    name: 'documentbuilder'
  }
};
